import React from 'react';
import styled from 'styled-components';
import { TextInline, ClickableElement } from '@cko/primitives';
const ThreeDotMenuItemButton = styled(ClickableElement) `
  text-align: left;
  padding: var(--layout-soybean) var(--layout-stamp);
  border-radius: var(--border-r-seed);
  font: var(--body-xs);

  :hover {
    background-color: var(--control-bg-decorative-hover);
  }
`;
/**
 * @deprecated - Please use the ActionMenu from UI Toolkit
 * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/actionmenu--docs}
 */
export const ThreeDotMenuItem = ({ id, onClick, testId, text, textColor, }) => {
    return (React.createElement(ThreeDotMenuItemButton, { "data-testid": testId, id: id, onClick: onClick },
        React.createElement(TextInline, { color: textColor, whiteSpace: "nowrap" }, text)));
};
